import React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ButtonGroup from "@mui/material/ButtonGroup";
import Button from "@mui/material/Button";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { BLACK, GREY, LIGHTGREY, WHITE } from "../../store/colorCode";
import PrintIcon from "@mui/icons-material/Print";
import Typography from "@mui/material/Typography";
import Print from "../common/PrintBox";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import Metadata from "../common/Metadata";
import { Box } from "@mui/material";

const StyleMenuItem = (props) => (
  <MenuItem
    sx={{
      textAlign: "left",
      width: "100%",
      display: "inline-block",
      fontSize: props.locale === "ml" || "kn" ? 15 : 18,
    }}
    {...props}
  >
    {props.children}
  </MenuItem>
);
const ITEM_HEIGHT = 80;
const Setting = ({
  fontSize,
  fontFamily,
  lineView,
  isHoverVerse,
  footNote,
  crossRef,
  setValue,
  settingsAnchor,
  handleClose,
  printRef,
  printNotes,
  setPrintNotes,
  printHighlights,
  setPrintHighlights,
  bookDisplay,
  chapter,
  mobileView,
  paneNo,
  metadataList,
  locale,
}) => {
  const open = Boolean(settingsAnchor);
  function setItem(key, value) {
    setValue(key, value);
    if (paneNo !== 2) {
      localStorage.setItem(key, value);
    }
  }
  const decreaseFontSize = () => {
    setItem("fontSize", fontSize > 12 ? fontSize - 1 : fontSize);
  };

  const increaseFontSize = () => {
    setItem("fontSize", fontSize < 25 ? fontSize + 1 : fontSize);
  };

  const setFontFamily = (event) => {
    setItem("fontFamily", event.currentTarget.getAttribute("value"));
  };
  const setVerseHover = (event) => {
    setItem("isHoverVerse", event.target.checked);
  };
  const setLineView = (event) => {
    setItem("lineView", event.target.checked);
  };
  const setFootNote = (event) => {
    setItem("footNote", event.target.checked);
  };
  const setCrossRef = (event) => {
    setItem("crossRef", event.target.checked);
  };
  const [dialogOpen, setDialogOpen] = React.useState(false);

  const handleDialogOpen = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };
  const { t } = useTranslation();
  return (
    <>
      <Menu
        id="long-menu"
        anchorEl={settingsAnchor}
        keepMounted
        open={open}
        onClose={handleClose}
        sx={{
          "& .MuiMenu-paper": {
            maxHeight: ITEM_HEIGHT * 5.5,
            width: locale === "ml" || "kn" ? "350px" : "280px",
            backgroundColor: WHITE,
            color: BLACK,
            marginTop: "35px",
          },
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <StyleMenuItem locale={locale}>
          {t("settingsFontFamily")}
          <ButtonGroup
            sx={{
              marginLeft: 1.875,
              "& .MuiButtonGroup-firstButton": {
                borderColor: LIGHTGREY,
              },
              maxWidth: { xs: locale === "ml" ? 155 : "unset", md: "unset" },
            }}
            variant="contained"
            aria-label="Large contained secondary button group"
          >
            <Button
              sx={{
                fontFamily: '"Roboto", "sans-serif"',
                textTransform: "none",
                fontSize: locale === "ml" || "kn" ? 12 : 16,
                color: "rgba(0, 0, 0, 0.87)",
                backgroundColor: "#e0e0e0",
                ...(fontFamily === "Sans" && {
                  background: "#c7c7c7",
                  boxShadow: "inset 1px 1px 5px #9a9a9a",
                }),
                "&:hover": {
                  color: "rgba(0, 0, 0, 0.87)",
                  backgroundColor: "lightgray",
                },
              }}
              onClick={setFontFamily}
              value="Sans"
            >
              {t("settingsFontSans")}
            </Button>
            <Button
              sx={{
                fontFamily: '"Roboto Slab", "serif"',
                textTransform: "none",
                fontSize: locale === "ml" || "kn" ? 12 : 16,
                color: "rgba(0, 0, 0, 0.87)",
                "&:hover": {
                  color: "rgba(0, 0, 0, 0.87)",
                  backgroundColor: "lightgray",
                },
                backgroundColor: "#e0e0e0",
                ...(fontFamily === "Serif" && {
                  background: "#c7c7c7",
                  boxShadow: "inset 1px 1px 5px #9a9a9a",
                }),
              }}
              onClick={setFontFamily}
              value="Serif"
            >
              {t("settingsFontSerif")}
            </Button>
          </ButtonGroup>
        </StyleMenuItem>
        <MenuItem
          sx={{
            textAlign: "left",
            width: "100%",
            display: "inline-block",
            fontSize: locale === "ml" || "kn" ? 15 : 18,
          }}
        >
          {t("settingsFontSize")}
          <ButtonGroup
            sx={{
              marginLeft: 4.375,
              "& .MuiButtonGroup-firstButton": {
                borderColor: GREY + "50",
              },
            }}
            variant="contained"
            aria-label="Large contained secondary button group"
          >
            <Button
              sx={{
                fontSize: 13,
                color: "rgba(0, 0, 0, 0.87)",
                backgroundColor: "#e0e0e0",
                "&:hover": {
                  color: "rgba(0, 0, 0, 0.87)",
                  backgroundColor: "lightgray",
                },
              }}
              onClick={decreaseFontSize}
            >
              {t("settingsFontSizeA")}-
            </Button>
            <Button
              sx={{
                fontSize: 16,
                color: "rgba(0, 0, 0, 0.87)",
                backgroundColor: "#e0e0e0",
                "&:hover": {
                  color: "rgba(0, 0, 0, 0.87)",
                  backgroundColor: "lightgray",
                },
              }}
              onClick={increaseFontSize}
            >
              {t("settingsFontSizeA")}+
            </Button>
          </ButtonGroup>
        </MenuItem>
        <StyleMenuItem locale={locale}>
          <FormControlLabel
            labelPlacement="start"
            label={
              <Typography
                sx={{
                  fontSize: locale === "ml" || "kn" ? 15 : 18,
                  marginLeft: -2.125,
                  marginRight: 2.25,
                }}
              >
                {t("settingsLineView")}
              </Typography>
            }
            control={
              <Switch
                checked={lineView}
                onChange={setLineView}
                name="lineView"
                color="default"
              />
            }
          />
        </StyleMenuItem>
        {mobileView ? (
          ""
        ) : (
          <StyleMenuItem locale={locale}>
            <FormControlLabel
              labelPlacement="start"
              label={
                <Typography
                  sx={{
                    fontSize: locale === "ml" || "kn" ? 15 : 18,
                    marginLeft: -2.125,
                  }}
                >
                  {t("hoverVerse")}
                </Typography>
              }
              control={
                <Switch
                  checked={isHoverVerse}
                  onChange={setVerseHover}
                  onClick={setVerseHover}
                  name="verseHover"
                  color="default"
                />
              }
            />
          </StyleMenuItem>
        )}
        <StyleMenuItem locale={locale}>
          <FormControlLabel
            labelPlacement="start"
            label={
              <Typography
                sx={{
                  fontSize: locale === "ml" || "kn" ? 15 : 18,
                  marginLeft: -2.125,
                  marginRight: 2.25,
                }}
              >
                {t("footnotes")}
              </Typography>
            }
            control={
              <Switch
                checked={footNote}
                onChange={setFootNote}
                onClick={setFootNote}
                name="footnote"
                color="default"
              />
            }
          />
        </StyleMenuItem>
        <StyleMenuItem locale={locale}>
          <FormControlLabel
            labelPlacement="start"
            label={
              <Typography
                sx={{
                  fontSize: locale === "ml" || "kn" ? 15 : 18,
                  marginLeft: -2.125,
                  marginRight: 2.25,
                }}
              >
                {t("crossReferences")}
              </Typography>
            }
            control={
              <Switch
                checked={crossRef}
                onChange={setCrossRef}
                onClick={setCrossRef}
                name="crossref"
                color="default"
              />
            }
          />
        </StyleMenuItem>
        <StyleMenuItem locale={locale}>
          <Box sx={{ display: "flex" }}>
            <Box sx={{ marginRight: "12px", display: "inline" }}>
              {t("informationText")}
            </Box>
            <Box
              sx={{
                display: "inline-block",
                marginTop: "-18px",
                flexGrow: 1,
              }}
            >
              <Metadata
                metadataList={metadataList}
                title="Version Name (in Eng)"
                abbreviation="Abbreviation"
                mobileView={mobileView}
              ></Metadata>
            </Box>
          </Box>
        </StyleMenuItem>
        <StyleMenuItem locale={locale} onClick={handleDialogOpen}>
          <Box sx={{ marginRight: 2.5, display: "inline" }}>
            {t("PrintSave")}
          </Box>
          <PrintIcon />
        </StyleMenuItem>
      </Menu>
      <Print
        dialogOpen={dialogOpen}
        handleDialogClose={handleDialogClose}
        bookDisplay={bookDisplay}
        printRef={printRef}
        printHighlights={printHighlights}
        setPrintNotes={setPrintNotes}
        setPrintHighlights={setPrintHighlights}
        printNotes={printNotes}
        chapter={chapter}
        locale={locale}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    mobileView: state.local.mobileView,
    locale: state.local.locale,
  };
};
export default connect(mapStateToProps)(Setting);
